/* ZCRAVE system pages behaviour: cart page updates, curated rail, promo, search sheet scrim, lost-password view. */
(function () {
  'use strict';
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  /* ---------- cart page: - / + / x re-render the section in place (theme.js only refreshes the drawer) ---------- */
  var cart = document.querySelector('[data-zcart]');
  if (cart) {
    var busy = false;
    document.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      var remove = e.target.closest('[data-line-remove]');
      var hit = step || remove;
      if (!hit || !cart.contains(hit) || busy) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var row = hit.closest('[data-line-key]');
      var qty = 0;
      if (step) {
        var input = row.querySelector('[data-qty-input]');
        qty = Math.max(0, Number(input.value) + Number(step.dataset.qtyStep));
      }
      busy = true;
      cart.style.opacity = '.6';
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: row.dataset.lineKey, quantity: qty })
      }).then(function () {
        return fetch(root + 'cart?section_id=' + encodeURIComponent(cart.dataset.sectionId));
      }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-zcart]');
        if (fresh) {
          cart.replaceWith(fresh);
          cart = fresh;
          var rails = document.querySelector('.zcart__rails');
          var freshRails = doc.querySelector('.zcart__rails');
          if (rails && !freshRails) rails.remove();
          initRail();
        }
        if (window.ZTHEME && window.ZTHEME.refreshCart) window.ZTHEME.refreshCart();
      }).catch(function () { location.reload(); }).finally(function () { busy = false; });
    }, true);

    /* promo code -> Shopify discount URL, back to the cart.
       Shopify's /discount/CODE route silently ignores a code it cannot honour:
       the page reloaded looking identical whether you typed EOS or gibberish.
       Remember what was tried, then say what happened once the cart comes back. */
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-zcart-promo]');
      if (!form) return;
      e.preventDefault();
      var code = (form.querySelector('input[name="discount"]').value || '').trim();
      if (!code) return;
      try { sessionStorage.setItem('zcv.promo.tried', code); } catch (err) {}
      location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + 'cart');
    });

    /* report the outcome of the code the shopper just tried */
    (function () {
      var tried = null;
      try { tried = sessionStorage.getItem('zcv.promo.tried'); } catch (err) {}
      if (!tried) return;
      try { sessionStorage.removeItem('zcv.promo.tried'); } catch (err) {}
      var msg = document.querySelector('[data-promo-msg]');
      if (!msg) return;
      fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var list = cart.discount_codes || [];
          var hit = null;
          for (var i = 0; i < list.length; i++) {
            if (String(list[i].code).toUpperCase() === tried.toUpperCase()) { hit = list[i]; break; }
          }
          var ok = !!(hit && hit.applicable);
          msg.textContent = ok
            ? 'CODE ' + tried.toUpperCase() + ' APPLIED.'
            : 'CODE ' + tried.toUpperCase() + ' IS NOT VALID FOR THIS ORDER.';
          msg.className = 'zcv2-promo__msg' + (ok ? ' is-ok' : ' is-err');
          msg.hidden = false;
        })
        .catch(function () {});
    })();
  }

  /* CURATED FOR YOU: 10 pieces, 5 visible, arrows page the flex track like the live navigation carousel.
     The arrow listener is bound ONCE (initRail runs again after every qty/remove re-render, and a
     listener per render made one arrow click jump N pages), and the page index survives the swap so
     the rail does not snap back to card 1 while the row above it updates. */
  var railTrack = null, railPage = 0, railPages = 1;
  function railGo(n) {
    if (!railTrack) return;
    railPage = Math.max(0, Math.min(railPages - 1, n));
    railTrack.style.transform = 'translateX(' + (-railPage * 100) + '%)';
    var prev = document.querySelector('[data-zcart-prev]'), next = document.querySelector('[data-zcart-next]');
    if (prev) prev.disabled = railPage === 0;
    if (next) next.disabled = railPage >= railPages - 1;
  }
  function initRail() {
    var rail = document.querySelector('[data-zcart-rail]');
    if (!rail) { railTrack = null; return; }
    railTrack = rail.querySelector('[data-zcart-track]');
    railPages = Math.max(1, Math.ceil((railTrack ? railTrack.children.length : 0) / 5));
    railGo(railPage);
  }
  document.addEventListener('click', function (e) {
    if (!railTrack) return;
    if (e.target.closest('[data-zcart-prev]')) railGo(railPage - 1);
    if (e.target.closest('[data-zcart-next]')) railGo(railPage + 1);
  });
  initRail();

  /* ---------- search results NARROW drawer: a Style pick navigates to its collection, tags + sizes + sort go back
     to /search?q= (patch-category.js builds collection URLs, so the search form takes over its View / Clear here) ---------- */
  var facets = document.querySelector('[data-search-facets]');
  if (facets) {
    var qv = (facets.querySelector('input[name="q"]') || {}).value || '';
    var searchUrl = function (extra) {
      var q = ['q=' + encodeURIComponent(qv), 'type=product'].concat(extra || []);
      return root + 'search?' + q.join('&');
    };
    document.addEventListener('click', function (e) {
      var view = e.target.closest('[data-narrow-view]');
      var clear = e.target.closest('[data-narrow-clear]');
      if (!view && !clear) return;
      var panel = (view || clear).closest('[data-narrow-panel]');
      if (!panel || !panel.contains(facets)) return;
      e.preventDefault();
      e.stopPropagation();
      if (clear) { location.href = searchUrl(); return; }
      var cat = facets.querySelector('[data-zc-cat]:checked');
      if (cat && cat.value) { location.href = cat.value; return; }
      var extra = [];
      facets.querySelectorAll('input[name^="filter."]').forEach(function (c) {
        if (c.type === 'checkbox' && !c.checked) return;
        if (!c.value) return;
        extra.push(encodeURIComponent(c.name) + '=' + encodeURIComponent(c.value));
      });
      var sel = facets.querySelector('select[name="sort_by"]');
      if (sel && sel.value && sel.value !== 'relevance') extra.push('sort_by=' + encodeURIComponent(sel.value));
      location.href = searchUrl(extra);
    }, true);
  }

  /* ---------- search sheet: live closes the popup when the dimmed page behind it is clicked ---------- */
  var panel = document.querySelector('[data-search-panel]');
  if (panel) {
    var closeSheet = function () { panel.classList.remove('is-open'); panel.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; };
    document.addEventListener('click', function (e) {
      if (!panel.classList.contains('is-open')) return;
      if (e.target === panel) closeSheet();
    });
  }

  /* ---------- accounts: #recover shows the live LOST PASSWORD page in place of the two columns ---------- */
  var acct = document.querySelector('[data-zacct]');
  if (acct) {
    var sync = function () {
      var on = location.hash === '#recover';
      acct.classList.toggle('zacct--recover', on);
      var hero = acct.querySelector('[data-zacct-recover-only]');
      var rec = acct.querySelector('[data-zacct-recover]');
      if (hero) hero.hidden = !on;
      if (rec) rec.hidden = !on;
      var lost = acct.querySelector('.lost_reset_password');
      if (on && lost) {
        var i = lost.querySelector('input[type="email"]');
        var ready = function () { lost.classList.toggle('is-ready', !!(i && i.value.trim())); };
        if (i) { i.addEventListener('input', ready); ready(); }
      }
    };
    window.addEventListener('hashchange', sync);
    sync();
  }
})();

/* live goya-child zcrave-carousels.js (cart rails): arrows scroll one card, wheel + pointer drag on the track. */
(function(){"use strict";function stepSize(track){const first=track.querySelector(".zc-slide");if(!first)return 300;const rect=first.getBoundingClientRect();const styles=getComputedStyle(track);const gap=parseFloat(styles.gap||styles.columnGap||styles.rowGap||"16")||16;return rect.width+gap}
function throttle(fn,wait){let t=0;return function(...args){const now=Date.now();if(now-t>=wait){t=now;fn.apply(this,args)}}}
function init(section){if(section.dataset.zcInit)return;section.dataset.zcInit="1";const track=section.querySelector(".zc-track");if(!track)return;const prev=section.querySelector(".zc-btn.prev");const next=section.querySelector(".zc-btn.next");let step=stepSize(track);const DRAG_PX=6;function scrollByDelta(d){track.scrollBy({left:d,behavior:"smooth"})}
prev&&prev.addEventListener("click",()=>scrollByDelta(-step));next&&next.addEventListener("click",()=>scrollByDelta(step));window.addEventListener("resize",throttle(()=>{step=stepSize(track)},150));track.addEventListener("wheel",(e)=>{const dx=Math.abs(e.deltaX);const dy=Math.abs(e.deltaY);if(dy>=dx){return}
const maxScroll=track.scrollWidth-track.clientWidth;if(maxScroll<=2)return;const atStart=track.scrollLeft<=1;const atEnd=track.scrollLeft>=maxScroll-1;const goingLeft=e.deltaX<0;const goingRight=e.deltaX>0;if((goingLeft&&!atStart)||(goingRight&&!atEnd)){e.preventDefault();track.scrollLeft+=e.deltaX}},{passive:!1});let isDown=!1;let moved=!1;let dragging=!1;let startX=0;let startY=0;let startLeft=0;
function onPointerDown(e){if(e.pointerType==="mouse"&&e.button!==0)return;isDown=!0;moved=!1;dragging=!1;startX=e.clientX;startY=e.clientY;startLeft=track.scrollLeft}
function onPointerMove(e){if(!isDown)return;const dx=e.clientX-startX;const dy=e.clientY-startY;if(!dragging){if(Math.abs(dx)>DRAG_PX&&Math.abs(dx)>Math.abs(dy)){dragging=!0;try{track.setPointerCapture(e.pointerId)}catch(_){}}else{return}}
moved=!0;e.preventDefault();track.scrollLeft=startLeft-dx}
function onPointerUp(e){try{track.releasePointerCapture(e.pointerId)}catch(_){}
if(dragging&&moved){e.preventDefault();e.stopPropagation()}
isDown=!1;moved=!1;dragging=!1}
track.addEventListener("pointerdown",onPointerDown);track.addEventListener("pointermove",onPointerMove,{passive:!1});track.addEventListener("pointerup",onPointerUp);track.addEventListener("pointercancel",onPointerUp);track.addEventListener("lostpointercapture",()=>{isDown=!1;moved=!1;dragging=!1});track.addEventListener("click",function(e){if(!dragging)return;e.preventDefault();e.stopPropagation()},!0)}
function boot(){document.querySelectorAll(".zc-carousel[data-zc-ready]").forEach(init)}
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",boot)}else{boot()}
const mo=new MutationObserver((muts)=>{muts.forEach((m)=>{Array.from(m.addedNodes||[]).forEach((node)=>{if(node.nodeType!==1)return;if(node.matches&&node.matches(".zc-carousel[data-zc-ready]")){init(node)}else if(node.querySelectorAll){node.querySelectorAll(".zc-carousel[data-zc-ready]").forEach(init)}})})});mo.observe(document.documentElement,{childList:!0,subtree:!0})})();
